import { defineNuxtPlugin } from "#imports";

export default defineNuxtPlugin(async (nuxtApp) => {
	if (process.client) {
    const data = { token: null, status: null, };
		// Your web app's Firebase configuration
		const firebaseConfig = {
			apiKey: "AIzaSyD8yB5HI5Xl4K8UpU3eUIu_rjWAjdG3oK8",
			authDomain: "vaidebolsa-prod.firebaseapp.com",
			projectId: "vaidebolsa-prod",
			storageBucket: "vaidebolsa-prod.appspot.com",
			messagingSenderId: "521203991665",
			appId: "1:521203991665:web:3aa2b5cc9ad2604f38c7d0",
			measurementId: "G-Y5LXTR4GYL",
		};

    try {

      const { initializeApp, firebase } = import("firebase/app");
      const { getAnalytics } = import("firebase/analytics");
      const { getMessaging, getToken } = import("firebase/messaging");

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const analytics = getAnalytics(app);
      const messaging = getMessaging(app);

      const getNewToken = async () => {
        if (data.token == null) {
          const token = await getToken(messaging, {
            vapidKey:
              "BFyIfitwt-0CmJOir_gamxZO9oq9p5xEIS5gF6PrJ7ZcoDEJfISaArClk7TRq_Bw4Q1Or0V1XroSAD-zUzMpaQo",
          });

          data.token = token;
          data.status = "granted";

          return token;
        }
        return data.token;
      };

  		const requestPermission = async () => {
  			console.log("Requesting permission...");
  			if (Notification.permission == "granted") {
          await getNewToken();
          return "granted";
  			}
  			return await Notification.requestPermission().then(async (permission) => {
  				console.log(permission);

  				if (permission === "granted") {
  					console.log("Notification permission granted.");

  					await getNewToken();
  				}

  				data.status = permission;

          return permission;
  			});
  		};

  		if (Notification.permission == "granted") {
  			await getNewToken();
  		}

  		return {
  			provide: {
  				firebase: {
  				  data,
  					app,
  					analytics,
  					messaging,
  					requestPermission,
  				},
  			},
  		};
    } catch (_e) {
      return {};
    }
	}
	return {};
});
